import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

let _appTz = 'America/New_York';

export function setAppTimezone(tz) {
  if (tz) _appTz = tz;
}

// 12-hour time with am/pm, for the Help Desk ticket screens.
export const TS_12H = 'YYYY-MM-DD h:mm A z';

export function formatTS(v, fmt = 'YYYY-MM-DD HH:mm z') {
  if (!v) return '-';
  return dayjs.utc(v).tz(_appTz).format(fmt);
}

/**
 * A duration as M:SS, rolling over to H:MM:SS past the hour.
 *
 * Three pages had their own copy that stopped at minutes, so a two-and-a-half
 * hour stretch on contact read as 145:46 -- correct, and unreadable at a
 * glance. Shared here so a fix lands once.
 *
 * Returns null for a missing value rather than a placeholder: what to show
 * instead is the caller's decision, and they do not agree ('-' vs an em dash).
 */
export function secsToDuration(seconds) {
  if (seconds == null || isNaN(seconds)) return null;
  const total = Math.max(0, Math.round(Number(seconds)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

/** The same, for a duration stored as a fraction of an hour, as CNE does. */
export function hrsToDuration(hrs) {
  if (hrs == null || isNaN(hrs)) return null;
  return secsToDuration(Number(hrs) * 3600);
}
